import React from 'react';
import { usePageData } from '../../contexts/DataContext';
import LoadingSpinner, { LoadingSkeleton } from '../common/LoadingSpinner';

const HowToSection = () => {
  const { data: homePage, isLoading, error } = usePageData('homePage');

  if (isLoading) {
    return (
      <section className="how-to-section">
        <div className="container">
          <LoadingSkeleton type="text" count={2} />
          <div className="steps">
            {[...Array(4)].map((_, i) => (
              <div className="step" key={i}>
                <LoadingSkeleton type="card" count={1} />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (error || !homePage || !homePage.steps) {
    return (
      <section className="how-to-section">
        <div className="container">
          <h2>How to Create Resume Online?</h2>
          <p className="subtitle">Four simple steps to your professional resume or slip.</p>

          <div className="steps">
            {[1, 2, 3, 4].map((num) => (
              <div className="step" key={num}>
                <div className="step-number">{num}</div>
                <h4>Step {num} Title</h4>
                <p>Step {num} description goes here.</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="how-to-section">
      <div className="container">
        <h2>{homePage.howto_title}</h2>
        <p className="subtitle">{homePage.howto_subtitle}</p>

        <div className="steps">
          {homePage.steps.map((step, index) => (
            <div className="step" key={index}>
              <div className="step-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToSection;